import TrainingMask from './TrainingMask'

export default TrainingMask
